<template>
    <div>
        <RewardDetail v-show="rewardState"/>
        
        <rewardDetailLoader v-show="!rewardState"/>
    </div>
</template>

<script>
//Store
import { mapGetters, mapActions } from "vuex";

//Components
import RewardDetail from "@/app/components/reward-detail/reward-detail";
import rewardDetailLoader from "@/app/skeleton-loader/reward-detail-loader/reward-detail-loader.vue";

export default {
    name: 'Reward-detail-view',
    components: { RewardDetail, rewardDetailLoader },
    computed: {
        ...mapGetters('rewardLoaderStore', {
                rewardState: 'get_reward_state'
            }
        )
    },
    created() {
        this.$router.onReady( () => {
                this.RESET_REWARD_STATES()
            } 
        )
    },
    destroyed() {
        this.RESET_REWARD_STATES()
    },
    methods: {
        ...mapActions('rewardLoaderStore', ['RESET_REWARD_STATES'])
    }
}
</script>